import classes from './PannelFooter.module.css'

export default function PannelFooter({children, padding, background}) {
    return <div className={`${classes.pannel_footer} ${padding ? classes[padding] : ''}`} style={{backgroundColor: background}}>
        {children}
    </div>
}